<template>
  <div class="container-fluid">
    <div class="page-title"><h3>Departamentos de paquete</h3></div>
    <div class="card mb-3">
      <div class="card-body">
        <div class="row g-2 align-items-end">
          <div class="col-md-4">
            <label class="form-label small text-muted mb-1">Nombre</label>
            <input v-model.trim="form.name" class="form-control" placeholder="Ej. Electrónicos" />
          </div>
          <div class="col-md-3">
            <label class="form-label small text-muted mb-1">Código</label>
            <input
              v-model.trim="form.code"
              class="form-control text-uppercase"
              placeholder="ELECTRONICOS"
            />
          </div>
          <div class="col-md-3">
            <div class="form-check mt-4">
              <input
                id="isOther"
                v-model="form.isOther"
                class="form-check-input"
                type="checkbox"
              />
              <label class="form-check-label" for="isOther">Es opción "Otro"</label>
            </div>
          </div>
          <div class="col-md-2">
            <button class="btn btn-primary w-100" :disabled="!canSubmit" @click="createItem">
              Agregar
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-body">
        <div v-if="items.length === 0" class="text-muted">No hay departamentos configurados.</div>
        <div v-else class="table-responsive">
          <table class="table align-middle">
            <thead>
              <tr>
                <th>Nombre</th>
                <th>Código</th>
                <th>Tipo</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in activeItems" :key="item.id">
                <td>{{ item.name }}</td>
                <td><code>{{ item.code }}</code></td>
                <td>{{ item.isOther ? 'Otro' : 'Estándar' }}</td>
                <td class="text-end">
                  <button class="btn btn-sm btn-outline-danger" @click="removeItem(item.id)">
                    Eliminar
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from 'sweetalert2';
import { packageDepartmentsApi } from '@/api/package-departments';

export default {
  name: 'DepartamentosPaquete',
  data() {
    return {
      items: [],
      form: { name: '', code: '', isOther: false },
    };
  },
  computed: {
    canSubmit() {
      return this.form.name.length >= 2 && this.form.code.length >= 2;
    },
    activeItems() {
      return (this.items || []).filter((item) => item.active !== false);
    },
  },
  mounted() {
    this.fetchItems();
  },
  methods: {
    async fetchItems() {
      const { data } = await packageDepartmentsApi.getAll();
      this.items = data || [];
    },
    async createItem() {
      if (!this.canSubmit) return;
      await packageDepartmentsApi.create({
        name: this.form.name,
        code: this.form.code.toUpperCase(),
        isOther: this.form.isOther,
      });
      this.form = { name: '', code: '', isOther: false };
      await this.fetchItems();
    },
    async removeItem(id) {
      const c = await Swal.fire({ icon: 'warning', title: 'Eliminar', showCancelButton: true });
      if (!c.isConfirmed) return;
      await packageDepartmentsApi.delete(id);
      await this.fetchItems();
    },
  },
};
</script>
